import { Component, OnInit, ElementRef, HostListener, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Variable } from 'src/app/model/Plan';

@Component({
    selector: 'app-variable-typeahead',
    templateUrl: './variable-typeahead.component.html',
    styleUrls: ['./variable-typeahead.component.css'],
    standalone: false
})
export class VariableTypeaheadComponent implements OnInit {
  queryText: string = "";
  showList: boolean = false;

  @ViewChild('variableInputText') varInputText: ElementRef;
  
  @Input() variables:Variable[]= [];
  @Input() type:string;
  @Input() variableName:string;
  @Input() identifier: string = '';

  @Output() enterKeyPressed: EventEmitter<string> = new EventEmitter();
  @Output() variableSelected: EventEmitter<Variable> = new EventEmitter();
  @Output() newVariableSelected: EventEmitter<string> = new EventEmitter();
  @Output() removeVariableBtnClicked: EventEmitter<string> = new EventEmitter();
  
  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  onEnterKeyPressed(): void{
    this.enterKeyPressed.emit(this.queryText);
    this.showList = false;
    this.variableName = this.queryText;
    this.queryText = '';
  }

  onVariableSelected(variable:Variable): void {
    this.showList = false;
    this.variableSelected.emit(variable);
  }

  onNewVariableSelected(newVarName:string): void {
    this.showList = false;
    this.newVariableSelected.emit(newVarName);
  }

  onRemoveVariableBtnClicked(newVarName:string): void {
    this.removeVariableBtnClicked.emit(newVarName);
  }

  @HostListener("document:click", ["$event"])
  clickout($event) {
    if (this.varInputText && !this.varInputText.nativeElement.contains($event.target)){
      this.showList = false;
      this.queryText = "";
    }
  }
}
